<script setup lang="ts">
interface IProps {
  title: string
  itemId?: string
}
withDefaults(defineProps<IProps>(), {
  title: '',
  itemId: '',
})
</script>

<template>
  <div class="flex flex-col gap-1">
    <h4 class="text-base sm:text-lg font-semibold text-gray-800 dark:text-white/90 skeleton-box">
      {{ title }}
    </h4>
    <p v-if="itemId" class="text-xs text-white bg-gray-300 py-0.5 rounded px-2 dark:bg-white/10">
      ID: <span class="font-bold">{{ itemId }}</span>
    </p>
  </div>
</template>
